module.exports = __webpack_public_path__ + "static/media/webdesign-services-img48.03e4e024.jpg";